import { ReminderMailInfo } from '@/remindModule/entities/reminder';
import { getAllReminders } from '@/businessRepository/reminderTable/driver';

/**
 * リマインダー情報を取得するUseCase
 */
export class GetReminderDataUseCase {
  /**
   * 組織の全リマインダー情報を取得する
   * @returns リマインダー情報の配列
   */
  async execute(): Promise<ReminderMailInfo[]> {
    try {
      const response = await getAllReminders();

      if (!response.success || !response.result) {
        return [];
      }

      return response.result as ReminderMailInfo[];
    } catch (error) {
      console.error('リマインダー情報の取得に失敗しました:', error);
      return [];
    }
  }

  /**
   * dataIdで特定のリマインダー情報を検索する
   * @param reminderDataId - 検索するリマインダーデータID
   * @param reminderList - 検索対象のリマインダーリスト
   * @returns 見つかったリマインダー情報（見つからない場合はnull）
   */
  findReminderById(reminderDataId: string, reminderList: ReminderMailInfo[]): ReminderMailInfo | null {
    return reminderList.find((reminder) => reminder.dataId === reminderDataId) || null;
  }
}
